import React, { Suspense, lazy } from 'react';
import { Header } from '../components/Header';
import { Hero } from '../components/Hero';
import { QuoteCalculator } from '../components/QuoteCalculator';
import { WhatsAppFloat } from '../components/WhatsAppFloat';

// QuoteCalculator is the #1 conversion element (ad traffic lands here), so it is
// bundled eagerly and renders together with the Hero — no lazy-load delay.
// Sections further below the fold stay code-split and are prefetched during
// browser idle time so they render instantly on scroll.
const Contact = lazy(() => import(/* webpackPrefetch: true */ '../components/Contact').then((m) => ({ default: m.Contact })));
const Services = lazy(() => import(/* webpackPrefetch: true */ '../components/Services').then((m) => ({ default: m.Services })));
const Gallery = lazy(() => import(/* webpackPrefetch: true */ '../components/Gallery').then((m) => ({ default: m.Gallery })));
const Reviews = lazy(() => import(/* webpackPrefetch: true */ '../components/Reviews').then((m) => ({ default: m.Reviews })));
const Footer = lazy(() => import(/* webpackPrefetch: true */ '../components/Footer').then((m) => ({ default: m.Footer })));

// Branded skeleton shown while below-fold chunks download (instead of a blank gap)
const SectionSkeleton = () => (
  <div className="py-20 px-4 sm:px-6 lg:px-8 bg-slate-50" aria-hidden="true" data-testid="section-skeleton">
    <div className="max-w-4xl mx-auto space-y-6 animate-pulse">
      <div className="h-9 w-64 mx-auto rounded-lg bg-[#1E3A5F]/15" />
      <div className="h-4 w-96 max-w-full mx-auto rounded bg-[#1E3A5F]/10" />
      <div className="h-64 rounded-2xl bg-[#1E3A5F]/10" />
    </div>
  </div>
);

const LandingPage = () => (
  <>
    <Header />
    <Hero />
    <QuoteCalculator />
    <Suspense fallback={<SectionSkeleton />}>
      <Contact />
      <Services />
      <Gallery />
      <Reviews />
      <Footer />
    </Suspense>
    <WhatsAppFloat />
  </>
);

export default LandingPage;
